<template>
  <div ref="mapModalHeaderContainer">
    <IonHeader @click="map.nextModalExpandState()" class="map-modal-header ion-no-border p-[10px] pb-0" color="white">
      <div class="w-20 mx-auto h-1 rounded-full bg-gray-300"></div>

      <slot></slot>
    </IonHeader>
  </div>
</template>

<script setup lang="ts">
import { useNewMap } from '@/stores/map/map.store';
import { createGesture, Gesture, GestureDetail, IonHeader } from '@ionic/vue';
import { ref, useTemplateRef, watch } from 'vue';

const map = useNewMap();
const mapModalHeaderContainer = useTemplateRef('mapModalHeaderContainer');
const gesture = ref<Gesture>();

watch(mapModalHeaderContainer, (el, old) => {
  if (el) {
    if (gesture.value) {
      gesture.value.destroy();
    }
    gesture.value = createGesture({
      el: el as any,
      direction: 'y',
      gestureName: 'swipe',
      onEnd,
    });
    gesture.value.enable();
  }
});

function onEnd(detail: GestureDetail) {
  if (detail.deltaY > 0 && map.modalExpandState !== 1) {
    map.previousModalExpandState();
  } else if (detail.deltaY < 0 && map.modalExpandState !== 3) {
    map.nextModalExpandState();
  }
}
</script>

<style scoped></style>
